
module.provider('ApiUrl', function() {
    var base = '/api';

    this.baseUrl = function(url) {
        if (angular.isDefined(url)) {
            base = url;
            return this;
        }
        return base;
    };

    function joinArguments() {
        return Array.prototype.join.call(arguments, '/');
    }

    function urlBuilder(base) {
        function builder() {
            return base.concat.apply(base, arguments).join('/');
        }
        builder.partial = function() {
            var newBase = Array.prototype.concat.apply(base, arguments);
            return urlBuilder(newBase);
        };
        return builder;
    }

    this.$get = [function() {
        return urlBuilder([base]);
    }];

});